import { render, staticRenderFns } from "./ClientConsulting.vue?vue&type=template&id=5cbe8411"
import script from "./ClientConsulting.vue?vue&type=script&lang=js"
export * from "./ClientConsulting.vue?vue&type=script&lang=js"
import style0 from "./ClientConsulting.vue?vue&type=style&index=0&id=5cbe8411&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports